/*
 * Cart review page: UpCart slide-out cart -> /cart?view=review -> checkout.
 *
 * Loaded on every page (layout/theme.liquid). Three parts:
 *
 * 1. UpCart's Checkout button goes to the cart review page instead of
 *    straight to checkout. Carts with anything from the merch or merch-bundles
 *    collections still go straight to checkout (product IDs from layout/theme.liquid).
 *    "Continue to Payment" on the review page hands the click back to
 *    UpCart's own (hidden) Checkout button, so checkout itself works exactly
 *    as it does from the drawer.
 *
 * 2. The review page (sections/totl-cart-review.liquid): carries on UpCart's
 *    reservation timer (same start time, kept by UpCart in sessionStorage),
 *    shows the "Still deciding?" reminder once at 5:00, turns the timer red
 *    for the last minute, and updates the cart with the Section Rendering
 *    API. The timer is only for show: nothing happens to the cart at 0:00.
 *
 * 3. The default /cart page isn't used: sections/main-cart.liquid sends
 *    visitors (e.g. the cart icon on Shopify's checkout page) to the home
 *    page with OPEN_CART_KEY set, and the UpCart drawer opens there.
 */
(function () {
  var ENTRY_KEY = 'totl-cart-review-entry';
  var REMINDER_KEY = 'totl-cart-review-reminder';
  var UPCART_TIMER_KEY = 'announcement_module_time';
  var OPEN_CART_KEY = 'totl-open-upcart';
  var REMINDER_AT = 300;
  var URGENT_AT = 60;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reviewUrl = root + 'cart?view=review';
  var passThrough = false;

  function session(action) {
    try {
      return action(window.sessionStorage);
    } catch (error) {
      return undefined;
    }
  }

  // Merch carts (collections/merch and merch-bundles, listed by layout/theme.liquid) skip the review page.
  function hasMerch(productIds) {
    var merch = (window.totlMerchProductIds || []).map(Number);
    return productIds.some(function (id) { return merch.indexOf(Number(id)) !== -1; });
  }

  function upcartCheckoutButton() {
    var host = document.getElementById('upCart');
    var scope = host && (host.shadowRoot || host);
    return scope ? scope.querySelector('a.upcart-checkout-button') : null;
  }

  // Checkout the way UpCart's own button does it; /checkout if UpCart isn't there.
  function goToCheckout() {
    var refresh = typeof window.upcartRefreshCart === 'function' ? window.upcartRefreshCart() : null;
    Promise.resolve(refresh).catch(function () {}).then(function () {
      var button = upcartCheckoutButton();
      if (!button) {
        window.location.href = root + 'checkout';
        return;
      }
      passThrough = true;
      try {
        button.click();
      } finally {
        passThrough = false;
      }
    });
  }

  // 1. Route UpCart's Checkout button. Capture phase on window runs before
  // UpCart's own handlers inside its shadow root.
  window.addEventListener('click', function (event) {
    if (passThrough) return;
    var path = event.composedPath ? event.composedPath() : [];
    var button = null;
    for (var i = 0; i < path.length; i++) {
      if (path[i].classList && path[i].classList.contains('upcart-checkout-button')) {
        button = path[i];
        break;
      }
    }
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var ids = (cart.items || []).map(function (item) { return item.product_id; });
        if (!cart.item_count || hasMerch(ids)) {
          goToCheckout();
          return;
        }
        session(function (storage) { storage.setItem(ENTRY_KEY, '1'); });
        window.location.href = reviewUrl;
      })
      .catch(goToCheckout);
  }, true);

  // 3. Open the UpCart drawer after a redirect from /cart, once UpCart has loaded.
  if (session(function (storage) { return storage.getItem(OPEN_CART_KEY); })) {
    session(function (storage) { storage.removeItem(OPEN_CART_KEY); });
    var tries = 0;
    var waitForUpcart = setInterval(function () {
      tries++;
      if (typeof window.upcartOpenCart === 'function' && document.getElementById('upCart')) {
        clearInterval(waitForUpcart);
        if (typeof window.totlOpenUpCart === 'function') {
          window.totlOpenUpCart();
        } else {
          window.upcartOpenCart();
        }
      } else if (tries > 50) {
        clearInterval(waitForUpcart);
      }
    }, 200);
  }

  // 2. The review page.
  var page = document.querySelector('[data-totl-cart-review]');
  if (!page) return;

  var designMode = window.Shopify && window.Shopify.designMode;

  if (!designMode) {
    // Only reachable from UpCart's Checkout button.
    if (session(function (storage) { return storage.getItem(ENTRY_KEY); }) === null) {
      window.location.replace(root);
      return;
    }
  }

  var sectionId = page.getAttribute('data-section-id');
  var errorBox = page.querySelector('[data-totl-cr-error]');
  var modal = page.querySelector('[data-totl-cr-modal]');
  var lastFocus = null;

  // Timer
  function timerLength() {
    var settings = window.upcartSettings && window.upcartSettings.upcartEditorSettings;
    var parts = String((settings && settings.announcementTimer) || '10:00').split(':');
    var seconds = (parseInt(parts[0], 10) || 0) * 60 + (parseInt(parts[1], 10) || 0);
    return seconds > 0 ? seconds : 600;
  }

  function timerStart() {
    var start = session(function (storage) {
      try {
        return Number(JSON.parse(storage.getItem(UPCART_TIMER_KEY)));
      } catch (error) {
        return 0;
      }
    });
    if (!start) {
      start = Date.now();
      session(function (storage) { storage.setItem(UPCART_TIMER_KEY, JSON.stringify(String(start))); });
    }
    return start;
  }

  var length = timerLength();
  var start = timerStart();
  var previousLeft = null;

  function tick() {
    var left = Math.max(0, length - Math.floor((Date.now() - start) / 1000));
    var minutes = Math.floor(left / 60);
    var seconds = left % 60;
    var text = minutes + ':' + (seconds < 10 ? '0' : '') + seconds;

    page.querySelectorAll('[data-totl-cr-time]').forEach(function (el) {
      if (el.textContent !== text) el.textContent = text;
    });
    page.setAttribute('data-timer', left <= 0 ? 'expired' : left <= URGENT_AT ? 'urgent' : 'reserved');
    page.classList.add('is-timer-ready');

    // Once per timer, when 5:00 passes while the page is open.
    if (previousLeft !== null && previousLeft > REMINDER_AT && left <= REMINDER_AT && left > 0) {
      var shownFor = session(function (storage) { return storage.getItem(REMINDER_KEY); });
      if (shownFor !== String(start)) {
        session(function (storage) { storage.setItem(REMINDER_KEY, String(start)); });
        openModal();
      }
    }
    previousLeft = left;
    if (left <= 0) closeModal();
  }

  // Reminder popup
  function openModal() {
    if (!modal || !modal.hidden) return;
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('totl-cr-modal-open');
    var dialog = modal.querySelector('[role="dialog"]');
    if (dialog) dialog.focus();
  }

  function closeModal() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.classList.remove('totl-cr-modal-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  if (modal) {
    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });
  }
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeModal();
  });

  // Cart updates
  function showError(message) {
    if (!errorBox) return;
    errorBox.textContent = message || '';
    errorBox.hidden = !message;
  }

  function render(html) {
    if (!html) {
      window.location.reload();
      return;
    }
    var next = new DOMParser().parseFromString(html, 'text/html');
    var fresh = next.querySelectorAll('[data-totl-cr-swap]');
    page.querySelectorAll('[data-totl-cr-swap]').forEach(function (el, index) {
      if (fresh[index]) el.replaceWith(fresh[index]);
    });
  }

  function updateCart(endpoint, body) {
    body.sections = sectionId;
    body.sections_url = window.location.pathname + '?view=review';
    showError('');
    page.classList.add('is-busy');

    return fetch(root + endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        render(data.sections && data.sections[sectionId]);
        if (typeof window.upcartRefreshCart === 'function') {
          Promise.resolve(window.upcartRefreshCart()).catch(function () {});
        }
      })
      .catch(function (error) {
        showError((error && (error.description || error.message)) || 'Something went wrong. Please try again.');
        return fetch(window.location.pathname + '?view=review&sections=' + sectionId)
          .then(function (response) { return response.json(); })
          .then(function (data) { render(data[sectionId]); })
          .catch(function () {});
      })
      .then(function () {
        page.classList.remove('is-busy');
      });
  }

  page.addEventListener('click', function (event) {
    var target = event.target.closest('button');
    if (!target || target.disabled || page.classList.contains('is-busy')) return;

    if (target.hasAttribute('data-totl-cr-checkout')) {
      closeModal();
      goToCheckout();
    } else if (target.hasAttribute('data-totl-cr-close')) {
      closeModal();
    } else if (target.hasAttribute('data-totl-cr-upsell')) {
      var turningOn = target.getAttribute('aria-checked') !== 'true';
      target.setAttribute('aria-checked', turningOn ? 'true' : 'false');
      if (turningOn) {
        updateCart('cart/add.js', {
          items: [{ id: Number(target.getAttribute('data-variant-id')), quantity: 1 }]
        });
      } else {
        var updates = {};
        (target.getAttribute('data-keys') || '').split(',').filter(Boolean).forEach(function (key) {
          updates[key] = 0;
        });
        updateCart('cart/update.js', { updates: updates });
      }
    }
  });

  tick();
  setInterval(tick, 1000);
})();
